// extracted by mini-css-extract-plugin
export default {"backdrop":"ModalGen_backdrop__MC8oz"};